export const SEARCH_PROVIDER_TYPES = {
  ebsco: "ebsco",
  proQuest: "proQuest",
};

const STORAGE_KEY = "searchCredentialSettings";
export const SEARCH_CREDENTIAL_SETTINGS_CHANGED =
  "searchCredentialSettingsChanged";

const emptyProvider = (credentialType) => ({
  credentialType,
  username: "",
  profile: "",
  isEnabled: false,
  hasSavedCredential: false,
});

export const getDefaultSearchCredentialSettings = () => ({
  [SEARCH_PROVIDER_TYPES.ebsco]: emptyProvider(SEARCH_PROVIDER_TYPES.ebsco),
  [SEARCH_PROVIDER_TYPES.proQuest]: emptyProvider(
    SEARCH_PROVIDER_TYPES.proQuest
  ),
});

export function normalizeSearchCredential(raw, credentialType) {
  const type =
    raw?.credentialType ??
    raw?.CredentialType ??
    raw?.type ??
    credentialType;
  const username =
    raw?.username ??
    raw?.Username ??
    raw?.userName ??
    raw?.UserName ??
    raw?.userId ??
    raw?.UserId ??
    "";
  const profile = raw?.profile ?? raw?.Profile ?? "";
  const isEnabled = Boolean(
    raw?.isEnabled ?? raw?.IsEnabled ?? raw?.enabled ?? raw?.Enabled ?? false
  );
  const hasSavedCredential = Boolean(
    raw &&
      (raw.id ??
        raw.Id ??
        raw.username ??
        raw.Username ??
        raw.userName ??
        raw.UserName ??
        raw.userId ??
        raw.UserId)
  );

  return {
    ...emptyProvider(type),
    credentialType: type,
    username,
    profile,
    isEnabled,
    hasSavedCredential,
  };
}

export function getSearchCredentialSettings() {
  const defaults = getDefaultSearchCredentialSettings();

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaults;

    const saved = JSON.parse(raw);
    return {
      ...defaults,
      [SEARCH_PROVIDER_TYPES.ebsco]: {
        ...defaults[SEARCH_PROVIDER_TYPES.ebsco],
        ...(saved[SEARCH_PROVIDER_TYPES.ebsco] || {}),
      },
      [SEARCH_PROVIDER_TYPES.proQuest]: {
        ...defaults[SEARCH_PROVIDER_TYPES.proQuest],
        ...(saved[SEARCH_PROVIDER_TYPES.proQuest] || {}),
      },
    };
  } catch {
    return defaults;
  }
}

export function saveSearchCredentialSettings(settings) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  window.dispatchEvent(new Event(SEARCH_CREDENTIAL_SETTINGS_CHANGED));
}

export function isSearchProviderEnabled(
  credentialType,
  settings = getSearchCredentialSettings()
) {
  return Boolean(settings[credentialType]?.isEnabled);
}

export function normalizeSearchCredentialResponse(data) {
  const body = data?.data ?? data;
  const records = Array.isArray(body)
    ? body
    : Array.isArray(body?.items)
      ? body.items
      : body == null
        ? []
        : [body];
  const defaults = getDefaultSearchCredentialSettings();

  return records.reduce((settings, record) => {
    const normalized = normalizeSearchCredential(record);
    if (defaults[normalized.credentialType]) {
      settings[normalized.credentialType] = normalized;
    }
    return settings;
  }, defaults);
}
